import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/welcome/welcome2.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 welcome-box" }
const _hoisted_2 = { class: "card-body pe-15 pe-sm-20 pe-md-0 pb-0 pt-15 pt-sm-20" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-6" }
const _hoisted_5 = { class: "title position-relative" }
const _hoisted_6 = { class: "fw-semibold mb-8" }
const _hoisted_7 = { class: "d-block text-black-emphasis fs-md-15 fs-lg-16" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-6 text-center mt-15 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "welcome-image"
  }),
  /*#__PURE__*/_createElementVNode("br")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('feature.home.welcome_message', {name: _ctx.user?.info.firstname ?? _ctx.user?.info.lastname ?? !_ctx.stateStoreInstance.user?.info.role?.is_custom_role ? _ctx.stateStoreInstance.user?.info.role.name : ''})), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('feature.home.welcome_subtitle')), 1 /* TEXT */)
          ])
        ]),
        _hoisted_8
      ])
    ])
  ]))
}